import { uiColors } from '~/common/styles/colors'
import { ButtonSize, ButtonVariant } from '../../button/types'

/**
 * Returns the loading spinner size based on button size
 */
export const getButtonLoadingSpinnerSize = (size: ButtonSize) => {
  switch (size) {
    case 'xsmall':
    case 'small':
    case 'medium':
      return '13px'
    case 'large':
      return '16px'
  }
}

export const getButtonLoadingSpinnerColor = (variant: ButtonVariant) => {
  switch (variant) {
    case 'primary':
    case 'secondary':
    case 'danger':
    case 'cta':
      return {
        color: uiColors.content.white,
      }
    case 'tertiary':
    case 'ghost':
    case 'true-ghost':
    case 'underline':
      return {
        color: uiColors.content.primary,
      }
  }
}
